import { CalendarPlus, UserCheck, UserRoundX, UsersRound } from "lucide-react";

const metricConfig = [
  { key: "total_users", label: "Total accounts", icon: UsersRound },
  { key: "active_users", label: "Active users", icon: UserCheck },
  { key: "new_users_this_week", label: "New this week", icon: CalendarPlus },
  { key: "suspended_users", label: "Suspended", icon: UserRoundX },
];

export default function AdminOverview({ overview }) {
  return (
    <section className="admin-overview" data-testid="admin-overview">
      {metricConfig.map(({ key, label, icon: Icon }) => (
        <article className="admin-metric" data-testid={`admin-metric-${key}`} key={key}>
          <div className="admin-metric-icon"><Icon size={17} strokeWidth={1.8} /></div>
          <div>
            <p>{label}</p>
            <strong>{overview[key]}</strong>
          </div>
        </article>
      ))}
    </section>
  );
}